import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS4() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs4.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS4
